import { useState, useEffect } from "react";
import { usePagination } from "react-instantsearch-hooks-web";
import ChevronLeft from "../../components/icons/chevron-left.svg";
import ChevronRight from "../../components/icons/chevron-right.svg";

export default function CustomPagination(props) {
  const {
    currentRefinement,
    nbPages,
    isFirstPage,
    isLastPage,
    refine,
  } = usePagination(props);

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  const [inputValue, setInputValue] = useState(String(currentRefinement + 1));

  useEffect(() => {
    setInputValue(String(currentRefinement + 1));
  }, [currentRefinement]);

  const handleSubmit = (event) => {
    event.preventDefault();
    const newPage = parseInt(inputValue);
    if (newPage >= 1 && newPage <= nbPages) {
      refine(newPage - 1); // Pages are zero-indexed, so we subtract 1.
      scrollToTop();
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
  };

  const handleKeyPress = (e) => {
    const charCode = e.which ? e.which : e.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      e.preventDefault();
    }
  };

  // on deselecting the input...
  const handleOnBlur = () => {
    const newPage = parseInt(inputValue);
    if (isNaN(newPage)) {
      setInputValue(String(currentRefinement + 1)); // Reset to current page if input is invalid.
    } else {
      const validPage = Math.min(Math.max(newPage, 1), nbPages);
      setInputValue(String(validPage)); // Update the input with the valid page number.
      refine(validPage - 1); // Pages are zero-indexed, so we subtract 1.
      scrollToTop();
    }
  };


  return (
    <form onSubmit={handleSubmit} className="pagination">
      {!isFirstPage && (
        <button
          type="button"
          onClick={() => {
            refine(currentRefinement - 1);
            scrollToTop();
          }}
          ariaLabel="Previous Page"
          className="flex center align-center" 
          style={{borderRadius:'50%'}}
          >
          <ChevronLeft />
        </button>
      )}

      <div className="pageInput">
        <input
          type="number"
          min={1}
          max={nbPages}
          value={inputValue}
          onChange={handleInputChange}
          onFocus={() => setInputValue("")}
          onKeyPress={handleKeyPress}
          onBlur={handleOnBlur}
          pattern="[0-9]*"
        />
        <span>of {nbPages}</span>
        {/* <button type="submit">Go</button> */}
      </div>

      {!isLastPage && (
        <button
          type="button"
          onClick={() => {
            refine(currentRefinement + 1);
            scrollToTop();
          }}
          ariaLabel="Next Page"
          className="flex center align-center"
          style={{borderRadius:'50%'}}
        >
          <ChevronRight />
        </button>
      )}
    </form>
  );
}